<template>
  <BaseCard class="background"/>
</template>

<script>
import BaseCard from '@/components/BaseCard/BaseCard'
export default {
  components: {
    BaseCard
  }
}
</script>

<style lang="scss" scoped>
.background {
  background-image: url('../../assets/img/topography.svg');
  background-repeat: repeat;
  background-size: 200% auto;
  background-position: center top;
}
</style>
